// extracted by mini-css-extract-plugin
export default {"root":"CoursePauseRequestedPage_root__gd55O"};